import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faCircle } from '@fortawesome/pro-regular-svg-icons'
import { faCircle as faSolidCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Preferences } from '@citruscamps/citrus-client'

interface Step {
  step: number
  icon: IconProp
}

interface IProps {
  preferences?: Preferences
  totalSteps: number
  currentStep: number
}

export const ProgressDots = (props: IProps): React.ReactElement => {
  const steps: Step[] = []

  for (let i = 0; i < props.totalSteps; i++) {
    const icon: IconProp =
      props.currentStep >= i ? (props.currentStep === i ? faSolidCircle : faCheckCircle) : faCircle
    steps.push({ step: i, icon })
  }

  const listItems = steps.map((step: Step, i: number) => (
    <FontAwesomeIcon
      key={['step', step.step].join(':')}
      className="progress-dot text-success mx-3"
      icon={step.icon}
    ></FontAwesomeIcon>
  ))

  return <div className="progress-dots mb-4">{listItems}</div>
}
